import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDzKfzaIuQW9aTWycMTOXBeSr_l5tkHLpE",
  authDomain: "only-business-966c3.firebaseapp.com",
  projectId: "only-business-966c3",
  storageBucket: "only-business-966c3.appspot.com",
  messagingSenderId: "3532225398",
  appId: "1:3532225398:web:7f6e39d7310b07b0955857",
  measurementId: "G-2NS09Q1JK6",
};

// Inițializează Firebase
const app = initializeApp(firebaseConfig);

// Exportă auth pentru verificări
export const FIREBASE_APP = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const FIREBASE_DB = getFirestore(FIREBASE_APP);
